import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";

export class VideoEmbeddedPlayClickEvent extends BaseAnalyticsEvent {
  videoId: String;
  gameId: Number;
  status: Number;
  totalDuration: Number;
  timeSeen: Number;
  isPreview: Number;

  constructor(params) {
    super('play-click', 'match-video', 'game-center');

    this.videoId = params.videoId;
    this.gameId = params.gameId;
    this.status = params.status;
    this.totalDuration = params.totalDuration;
    this.timeSeen = params.timeSeen;
    this.isPreview = params.isPreview;
  }

  get properties() {
    const properties = super.properties;

    properties.videoId = this.videoId;
    properties.gameId = this.gameId;
    properties.status = this.status;
    properties.totalDuration = this.totalDuration;
    properties.timeSeen = this.timeSeen;
    properties.isPreview = this.isPreview;

    return properties;
  }
}